export const formatDateToLocalISO = (date: Date | null): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getReservoDayOfWeek = (date: Date): number => (
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getDay()
);
